import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-item-details',
  templateUrl: './item-details.component.html',
  styleUrls: ['./item-details.component.scss']
})
export class ItemDetailsComponent implements OnInit {


  private _itemNum: string = '';
  private _chain: string = '';
  private _generic: string = '';
  private _dc: string = '';
  private _itemDesc: string = '';
  private _purchaseUOM: string = '';
  private _packSize: string = '';
  private _packUom: string = '';
  private _maxQuantity: string = '';
  private _criticalItem: boolean = false;
  private _active: boolean = false;
  private _restriction: boolean = false;
  private _enforce: boolean = false;
  private _binBay: string = '';
  private _cubeSize: string = '';
  private _xrefFactor: string = '';
  private _itemPrice: string = '';
  private _glCode: string = '';
  private _catchWeight: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

  get itemNum(): string {
    return this._itemNum;
  }

  set itemNum(value: string) {
    this._itemNum = value;
  }

  get chain(): string {
    return this._chain;
  }

  set chain(value: string) {
    this._chain = value;
  }

  get generic(): string {
    return this._generic;
  }

  set generic(value: string) {
    this._generic = value;
  }

  get dc(): string {
    return this._dc;
  }

  set dc(value: string) {
    this._dc = value;
  }

  get itemDesc(): string {
    return this._itemDesc;
  }

  set itemDesc(value: string) {
    this._itemDesc = value;
  }

  get purchaseUOM(): string {
    return this._purchaseUOM;
  }

  set purchaseUOM(value: string) {
    this._purchaseUOM = value;
  }

  get maxQuantity(): string {
    return this._maxQuantity;
  }

  set maxQuantity(value: string) {
    this._maxQuantity = value;
  }

  get criticalItem(): boolean {
    return this._criticalItem;
  }

  set criticalItem(value: boolean) {
    this._criticalItem = value;
  }

  get active(): boolean {
    return this._active;
  }

  set active(value: boolean) {
    this._active = value;
  }

  get restriction(): boolean {
    return this._restriction;
  }

  set restriction(value: boolean) {
    this._restriction = value;
  }

  get enforce(): boolean {
    return this._enforce;
  }

  set enforce(value: boolean) {
    this._enforce = value;
  }

  get binBay(): string {
    return this._binBay;
  }

  set binBay(value: string) {
    this._binBay = value;
  }

  get cubeSize(): string {
    return this._cubeSize;
  }

  set cubeSize(value: string) {
    this._cubeSize = value;
  }

  get xrefFactor(): string {
    return this._xrefFactor;
  }

  set xrefFactor(value: string) {
    this._xrefFactor = value;
  }

  get itemPrice(): string {
    return this._itemPrice;
  }

  set itemPrice(value: string) {
    this._itemPrice = value;
  }

  get glCode(): string {
    return this._glCode;
  }

  set glCode(value: string) {
    this._glCode = value;
  }

  get catchWeight(): boolean {
    return this._catchWeight;
  }

  set catchWeight(value: boolean) {
    this._catchWeight = value;
  }
  get packSize(): string {
    return this._packSize;
  }

  set packSize(value: string) {
    this._packSize = value;
  }

  get packUom(): string {
    return this._packUom;
  }

  set packUom(value: string) {
    this._packUom = value;
  }

}
